import type { FunctionComponent } from 'react';
import { Markdown } from '../../../../components/markdown';
import type { BentoPieceSquareCounterFragment } from '../../../../graphql/queries/GetBentoPieceSquareCounter.graphql';
import { usePersonalizations } from '../../../../lib/hooks/usePersonalizations';
import { renderTemplate } from '../../../../lib/utils/text';
import variables from '../../../../styles/variables.module.scss';
import { ActionButton } from '../../../action-button';
import styles from './bento-square-counter.module.scss';
export const BentoSquareCounter: FunctionComponent<Props> = ({
  smallerVersion = false,
  counter = '',
  heading = '',
  subtitle = '',
  backgroundColor = 'darkGray',
  button
}) => {
  const personalizations = usePersonalizations();
  function getBackgroundStyle() {
    return {
      backgroundColor: variables[backgroundColor]
    };
  }
  return <div className={styles.boxOne} style={getBackgroundStyle()} data-sentry-component="BentoSquareCounter" data-sentry-source-file="bento-square-counter.tsx">
            <div className={styles.boxOneContent}>
                <div className={styles.boxOneCopy}>
                    <div className={`${styles.number} ${styles.headinggradient} ${smallerVersion ? styles.smallerVersion : ''}`}>
                        {counter}
                    </div>

                    <div className={styles.copy}>
                        <div className={`${styles.heading} ${smallerVersion ? styles.smallerVersion : ''}`}>
                            <Markdown tag='h3' typeStyle={{
              _: 'heading-xs',
              md: 'heading-md',
              lg: 'heading-lg'
            }} markdown={renderTemplate(heading, personalizations)} data-sentry-element="Markdown" data-sentry-source-file="bento-square-counter.tsx" />
                        </div>
                        <div className={styles.subtitle}>
                            <Markdown tag='p' typeStyle={{
              _: 'body-lg',
              md: 'body-md'
            }} markdown={renderTemplate(subtitle, personalizations)} data-sentry-element="Markdown" data-sentry-source-file="bento-square-counter.tsx" />
                        </div>
                        {button?.title && <div className={styles.button}>
                                <ActionButton {...button} />
                            </div>}
                    </div>
                </div>
            </div>
        </div>;
};
export default BentoSquareCounter;
type Props = Omit<BentoPieceSquareCounterFragment, 'sys' | 'type'> & {
  index?: number;
  button?: object;
};